<div>
	<h1>Step 1: Download any templates or reference documents you may need</h1>
	<div class="downloads">
		<div>
			<a (click)="downloadYourProducts()">Your Products</a>
			<nz-icon nzType="download" nzTheme="outline" />
		</div>
		<div>
			<a (click)="downloadRubrics()">Rubrics</a>
			<nz-icon nzType="download" nzTheme="outline" />
		</div>
		<div>
			<a (click)="downloadGroups()">Groups</a>
			<nz-icon nzType="download" nzTheme="outline" />
		</div>
		<div>
			<a (click)="downloadSkills()">Skills</a>
			<nz-icon nzType="download" nzTheme="outline" />
		</div>
		<div>
			<a (click)="downloadCsvSpec()">CSV Spec</a>
			<nz-icon nzType="download" nzTheme="outline" />
		</div>
	</div>

	<div class="steps">
		@for (step of selectedSteps(); track step) {
			<div class="step-box">
				<h3>{{ step }}</h3>
				<h4>CSV Templates</h4>
				<div class="download-links">
					@switch (step) {
						@case (SetupWizardSteps.USERS) {
							<div>
								<nz-icon nzType="download" nzTheme="outline" />
								<a (click)="downloadStepCsvTemplate(SetupWizardPayloadObjectKeys.users)">Users</a>
							</div>
							<div>
								<nz-icon nzType="download" nzTheme="outline" />
								<a (click)="downloadStepCsvTemplate(SetupWizardPayloadObjectKeys.usersToSections)">
									User to Section
								</a>
							</div>
						}
						@case (SetupWizardSteps.LOCATIONS) {
							<div>
								<nz-icon nzType="download" nzTheme="outline" />
								<a (click)="downloadStepCsvTemplate(SetupWizardPayloadObjectKeys.locations)">
									Locations
								</a>
							</div>
							<div>
								<nz-icon nzType="download" nzTheme="outline" />
								<a
									(click)="
										downloadStepCsvTemplate(SetupWizardPayloadObjectKeys.schoolAdminsToLocations)
									"
								>
									School Admin to Location
								</a>
							</div>
						}
						@case (SetupWizardSteps.SECTIONS) {
							<div>
								<nz-icon nzType="download" nzTheme="outline" />
								<a (click)="downloadStepCsvTemplate(SetupWizardPayloadObjectKeys.sections)">Sections</a>
							</div>
						}
						@case (SetupWizardSteps.COURSE_WORK) {
							<div>
								<nz-icon nzType="download" nzTheme="outline" />
								<a (click)="downloadStepCsvTemplate(SetupWizardPayloadObjectKeys.courses)">Courses</a>
							</div>
							<div>
								<nz-icon nzType="download" nzTheme="outline" />
								<a (click)="downloadStepCsvTemplate(SetupWizardPayloadObjectKeys.units)">Units</a>
							</div>
							<div>
								<nz-icon nzType="download" nzTheme="outline" />
								<a (click)="downloadStepCsvTemplate(SetupWizardPayloadObjectKeys.lessons)">Lessons</a>
							</div>
							<div>
								<nz-icon nzType="download" nzTheme="outline" />
								<a (click)="downloadStepCsvTemplate(SetupWizardPayloadObjectKeys.activities)">
									Activities
								</a>
							</div>
							<div>
								<nz-icon nzType="download" nzTheme="outline" />
								<a (click)="downloadStepCsvTemplate(SetupWizardPayloadObjectKeys.contents)">Contents</a>
							</div>
						}
					}
				</div>
				<h4>CSV Specifications</h4>
				<div class="download-links">
					@switch (step) {
						@case (SetupWizardSteps.USERS) {
							<div>
								<nz-icon nzType="download" nzTheme="outline" />
								<a (click)="downloadStepCsvSpecification(SetupWizardPayloadObjectKeys.users)">Users</a>
							</div>
							<div>
								<nz-icon nzType="download" nzTheme="outline" />
								<a (click)="downloadStepCsvSpecification(SetupWizardPayloadObjectKeys.usersToSections)">
									User to Section
								</a>
							</div>
						}
						@case (SetupWizardSteps.LOCATIONS) {
							<div>
								<nz-icon nzType="download" nzTheme="outline" />
								<a (click)="downloadStepCsvSpecification(SetupWizardPayloadObjectKeys.locations)">
									Locations
								</a>
							</div>
							<div>
								<nz-icon nzType="download" nzTheme="outline" />
								<a
									(click)="
										downloadStepCsvSpecification(
											SetupWizardPayloadObjectKeys.schoolAdminsToLocations
										)
									"
								>
									School Admin to Location
								</a>
							</div>
						}
						@case (SetupWizardSteps.SECTIONS) {
							<div>
								<nz-icon nzType="download" nzTheme="outline" />
								<a (click)="downloadStepCsvSpecification(SetupWizardPayloadObjectKeys.sections)">
									Sections
								</a>
							</div>
						}
						@case (SetupWizardSteps.COURSE_WORK) {
							<div>
								<nz-icon nzType="download" nzTheme="outline" />
								<a (click)="downloadStepCsvSpecification(SetupWizardPayloadObjectKeys.courses)">
									Courses
								</a>
							</div>
							<div>
								<nz-icon nzType="download" nzTheme="outline" />
								<a (click)="downloadStepCsvSpecification(SetupWizardPayloadObjectKeys.units)">Units</a>
							</div>
							<div>
								<nz-icon nzType="download" nzTheme="outline" />
								<a (click)="downloadStepCsvSpecification(SetupWizardPayloadObjectKeys.lessons)">
									Lessons
								</a>
							</div>
							<div>
								<nz-icon nzType="download" nzTheme="outline" />
								<a (click)="downloadStepCsvSpecification(SetupWizardPayloadObjectKeys.activities)">
									Activities
								</a>
							</div>
							<div>
								<nz-icon nzType="download" nzTheme="outline" />
								<a (click)="downloadStepCsvSpecification(SetupWizardPayloadObjectKeys.contents)">
									Contents
								</a>
							</div>
						}
					}
				</div>
			</div>
		}
	</div>

	<h1>Step 2: Upload any CSVs based on the above templates</h1>
	<p>
		(Note: This step is entirely optional. You can skip the uploads and go straight to editing. You will have a
		chance to preview and edit all uploads before finalizing on the following pages.)
	</p>

	<div class="dropzone">
		<app-dropzone
			[accept]="'.csv'"
			[multiple]="true"
			[directory]="false"
			(onCompleted)="onDropCompleted($event)"
			title="Click or drag to upload"
		></app-dropzone>
	</div>

	<h1>Step 3: Apply the pending files to the preview</h1>
	<p>(Note: If something went wrong you can remove the pending file, fix it, and try again.)</p>

	<div class="file-manager">
		<app-setup-wizard-csv-file-manager
			(onApplyPreview)="onApprovedFile($event)"
			#fileManager
		></app-setup-wizard-csv-file-manager>
	</div>

	<h1>Step 4: Continue to Preview &amp; Edit</h1>

	<div class="preview-stats">
		<app-setup-wizard-preview-stats
			[steps]="selectedSteps()"
			[preview]="preview()"
		></app-setup-wizard-preview-stats>
	</div>

	<div class="continue-button">
		...
		<!--button
			nz-button
			nzType="primary"
			(click)="nav.navigate(['my', 'admin', 'setup-wizard', SetupWizardState.EDIT_STEPS_ACCOUNT])"
		>
			Continue to Preview & Edit
		</button-->
	</div>
</div>
